import { drawRoundRect } from "@gameApp/helpers/canvas/draw/rectRounded";
import { drawTextPure } from "@gameApp/helpers/canvas/draw/textPure";
import { getContextFont } from "@gameApp/helpers/canvas/getContextFont";
import colors from "tailwindcss/colors";
import { BASE_FONT_SIZE, SMALL_FONT_SIZE } from "../constants";

interface Params {
  context: CanvasRenderingContext2D;
  translateX: number;
  translateY: number;
  coefficient: number;
}

const RECT_RADIUS = 8;
const RECT_WIDTH = 50;
const RECT_HEIGHT = 20;
const RECT_HORIZONTAL_PADDING = 4;
const RECT_VERTICAL_PADDING = 2;
const GAP = 4;

export function miniGameOrderOverviewSnapshotDrawFeaturedAssetBonus({
  context,
  translateX,
  translateY,
  coefficient,
}: Params): void {
  const rectY = calculateRectY(translateY);
  const gradient = createGradient(context, translateX, rectY);

  drawRoundRect({
    context,
    width: RECT_WIDTH,
    height: RECT_HEIGHT,
    x: translateX,
    y: rectY,
    radius: RECT_RADIUS,
    stroke: false,
    contextOptions: {
      fillStyle: gradient,
    },
  });
  drawText(context, translateX, translateY, coefficient);
}

function calculateRectY(translateY: number): number {
  return translateY - RECT_HEIGHT / 2 - RECT_VERTICAL_PADDING;
}

function createGradient(
  context: CanvasRenderingContext2D,
  translateX: number,
  rectY: number,
): CanvasGradient {
  const gradient = context.createLinearGradient(
    translateX,
    rectY,
    translateX + RECT_WIDTH,
    rectY + RECT_HEIGHT,
  );
  gradient.addColorStop(0, "#28CFFE");
  gradient.addColorStop(1, "#B623FA");
  return gradient;
}

function drawText(
  context: CanvasRenderingContext2D,
  translateX: number,
  translateY: number,
  coefficient: number,
): void {
  drawTextPure({
    context,
    text: `X${coefficient} DPS`,
    x: translateX + RECT_HORIZONTAL_PADDING,
    y: translateY + RECT_VERTICAL_PADDING,
    contextOptions: {
      font: getContextFont({ size: SMALL_FONT_SIZE, weight: 600 }),
      fillStyle: colors.white,
    },
  });

  drawTextPure({
    context,
    text: "Bonus for Featured Asset",
    x: translateX + RECT_WIDTH + GAP,
    y: translateY + RECT_VERTICAL_PADDING,
    contextOptions: {
      font: getContextFont({ size: BASE_FONT_SIZE, weight: 500 }),
      fillStyle: colors.white,
    },
  });
}
